module.exports = __webpack_public_path__ + "static/media/unverified_org.73159d42.svg";